import {cn} from 'lib/utils';
import {ChevronDown} from 'lucide-react';
import {Input} from '../primitives/imput/input';
import {Button} from '../primitives/button/button';
import {Checkbox} from '../primitives/checkbox/checkbox';
import {useConsentStore} from "../../../lib/store/consent-store";
import React, {useEffect} from "react";
import {Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle} from '../dialog/dialog';
import {useState} from 'react';
import {IMaskInput} from "react-imask";
import {useSendForm} from "../../../lib/hooks/use-send-form";

interface HeroFormProps {
  isFirstFormOpened: boolean;
  handleOpenFirstForm: () => void;
}

export const HeroFormPsk = ({
                              isFirstFormOpened,
                              handleOpenFirstForm,
                            }: HeroFormProps) => {
  const consent = useConsentStore(state => state.consent);
  const updateConsent = useConsentStore(state => state.updateConsent);

  const [isOpen, setIsOpen] = useState(false);

  const [termsChecked, setTermsChecked] = useState(false);
  const [termsError, setTermsError] = useState(false)
  const [fieldsError, setFieldsError] = useState(false)

  const [success, setSuccess] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    phone: ''
  })

  const {sendForm, isPending, error} = useSendForm()

  useEffect(() => {
    setFieldsError(false)
  }, [formData])

  useEffect(() => {
    setTermsError(false)
  }, [termsChecked]);

  const handleInputChange = (value: string, name: string) => {
    setFormData({...formData, [name]: value})
  }

  const validateFormAndSend = () => {
    if (formData.name === '' || formData.phone === '') {
      setFieldsError(true)
      return
    }

    if (!termsChecked) {
      setTermsError(true)
      return
    }

    sendForm(formData, 'getHeroMortgage', () => {
      setSuccess(true)
    })
  }


  return (
    <div className={cn('bg-plt-white rounded-xl w-[310px] transition-all')}>
{/*       {!isFirstFormOpened && (
        <button
          onClick={handleOpenFirstForm}
          className="flex justify-between items-center bg-plt-secondary rounded-xl px-8 py-[6px] w-[310px] font-open-sans-condensed"
        >
          <span className="text-plt-white text-xl font-bold shrink-0 tracking-[-3%] text-left">
            ПСК: 17,571% – 17,847% <br/> Семейная ипотека от 6%
          </span>
          <ChevronDown className="shrink-0 text-plt-white"/>
        </button>
      )} */}
      {isFirstFormOpened && (
        <div className="flex flex-col items-center p-6">
          <div className="grid gap-[14px]">
            <div className="grid gap-1">
              <p
                className="max-w-[168px] w-full mx-auto text-center bg-plt-secondary text-plt-white font-semibold rounded-full">
                ПСК: 17,571% – 17,847%
              </p>
              <p
                className="max-w-[178px] w-full px-3 mx-auto text-center bg-plt-secondary text-plt-white font-semibold rounded-full">
                Семейная ипотека от 6%
              </p>
            </div>
            <p className="text-center max-w-[185px] w-full mx-auto">
              УЗНАЙТЕ ПОДРОБНЕЕ ОБ ИПОТЕКЕ
            </p>
            <div className="max-w-[180px] w-full mx-auto grid gap-1.5">
              <Input value={formData.name} onChange={e => handleInputChange(e.target.value, 'name')}
                     className="rounded-[5px]" placeholder="Ваше имя"/>
              <IMaskInput value={formData.phone} onAccept={value => handleInputChange(value, 'phone')}
                          mask={'+7 (000) 000-00-00'} placeholder={'Ваш телефон'} className={cn(
                'ym-record-keys placeholder:text-plt-dark-gray selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-plt-gray flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
                'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                'rounded-[5px] h-8'
              )}/>
              <Button disabled={isPending} onClick={validateFormAndSend}
                      className="text-[15px] font-semibold font-open-sans">
                Оставить заявку
              </Button>
              {termsError &&
                  <p className='text-xs text-red-500'>Пожалуйста, дайте согласие на обработку персональных данных</p>}
              {fieldsError && <p className='text-xs text-red-500'>Пожалуйста, заполните все поля перед отправкой</p>}
            </div>
            {success &&
                <p className='py-3 rounded text-center text-xs text-green-500 border border-solid border-green-500'>Форма
                  успешно
                  отправлена, спасибо!</p>}
            <div className="flex items-center max-w-[257px] w-full mx-auto gap-1">
              <Checkbox
                checked={termsChecked}
                onCheckedChange={(checked) => setTermsChecked(checked === true)}
                id="terms"
                className="border-plt-gray size-[14px] rounded-[1px]"
              />
              <label
                htmlFor="terms"
                className="text-[10px] text-plt-dark-gray font-semibold tracking-[-3%] w-[243px]"
              >
                Нажимая кнопку «Оставить заявку», вы даете согласие на обработку
                персональных данных и соглашаетесь с политикой
                конфиденциальности
              </label>
            </div>
            <div className="flex items-center gap-2">
              <Checkbox id={'consent'} checked={consent} onCheckedChange={(checked) => updateConsent(checked === true)}
                        className="border-plt-dark-gray"/>
              <label className="text-plt-dark-gray text-[10px] leading-[120%]" htmlFor='consent'>
                Я ознакомлен (-на) с правилами обработки куки
              </label>
            </div>
            <a
              href={'javascript:void(0)'}
              className="text-xs text-plt-black tracking-[-3%] underline text-center"
              onClick={(e) => {
                e.preventDefault();
                setIsOpen(true)
              }}
            >
              Подробнее об условиях ипотеки
            </a>
          </div>
        </div>
      )}
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="bg-[#FAFAFC] border-none w-[670px]">
          <div className="flex justify-between mt-5 flex-col">
            <p>ПСК: 17,571% – 17,847%, Семейная ипотека от 6%</p>
            <p>Полная стоимость кредита 17,571–17,847%. Ставка 6% годовых доступна в рамках программы ПАО Сбербанк «Семейная ипотека» при приобретении строящегося жилья (квартира) у юридического лица по ДДУ. Изучите все условия кредита (займа), включая информацию о возможных дополнительных расходах:  <a
                href='https://www.sberbank.ru/ru/person/credits/home/family'>https://www.sberbank.ru/ru/person/credits/home/family</a>
            </p>
            <p>Предложение действительно в период с 26.06.2026 по 31.12.2030 г. вкл. Ипотечное кредитование осуществляется ПАО Сбербанк, генеральная лицензия Банка России на осуществление банковских операций № 1481 от 11.08.2015 г. Подробнее об условиях кредитования в ПАО Сбербанк, необходимых документах, ограничениях уточняйте на сайте www.sberbank.ru. Банк вправе отказать в предоставлении кредита без объяснения причин. Застройщик ООО «СЗ «НАРАСТРОЙ-М». Проектная декларация на сайте наш.дом.рф. Не является публичной офертой. ОЦЕНИВАЙТЕ СВОИ ФИНАНСОВЫЕ ВОЗМОЖНОСТИ И РИСКИ.</p>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
